module.exports = __webpack_public_path__ + "img/services-case3-3.f2da2618.png";